import type { Entity, Evidence } from '../../types';
export type Clue = Entity;
export type Case = Entity;
export type Correction = Entity;
export type ReviewConclusion =
  | 'confirmed'
  | 'partial'
  | 'excluded'
  | 'needsInfo';
export const conclusionLabels: Record<ReviewConclusion, string> = {
  confirmed: '成立',
  partial: '部分成立',
  excluded: '不成立',
  needsInfo: '信息不足',
};
export interface ReviewRound {
  uuid: string;
  round: number;
  sourceClueUuid: string;
  reviewerMemberUuid: string;
  actorMemberUuid?: string;
  conclusion: ReviewConclusion;
  opinion: string;
  confirmedScope: string;
  evidenceRefs: Evidence[];
  submittedAt: string;
  supersedesRoundUuid?: string;
}
export interface CaseMeasure {
  uuid: string;
  taskUuid: string;
  title: string;
  ownerMemberUuid: string;
  dueAt: string;
  required: boolean;
  result?: string;
  completedAt?: string;
}
export interface CaseHistory {
  uuid: string;
  action: string;
  note: string;
  at: string;
  actorMemberUuid?: string;
  viewMemberUuid: string;
  previousStatus: string;
  nextStatus: string;
  previousDueAt?: string;
  nextDueAt?: string;
  result?: string;
}
export interface ReferenceImpact {
  uuid: string;
  sourceUuid: string;
  sourceVersionUuid?: string;
  targetUuid: string;
  targetKind: Entity['kind'];
  correctionUuid: string;
  status: 'pending' | 'acknowledged';
  acknowledgedAt?: string;
  acknowledgedByMemberUuid?: string;
  at: string;
}
export interface ReviewEvent {
  uuid: string;
  type:
    | 'review.submitted'
    | 'case.created'
    | 'case.accepted'
    | 'case.reopened'
    | 'case.extended'
    | 'correction.decided';
  sourceUuid: string;
  at: string;
  actorMemberUuid: string;
  sourceRevision: number;
}
export type CorrectionKind =
  | 'transcript'
  | 'conclusion'
  | 'association'
  | 'speaker';
export const correctionLabels: Record<CorrectionKind, string> = {
  transcript: '转写文本',
  conclusion: '人工结论',
  association: '课程关联',
  speaker: '说话人角色',
};
